import { render, staticRenderFns } from "./user_info.vue?vue&type=template&id=c9faa016&scoped=true"
import script from "./user_info.vue?vue&type=script&lang=js"
export * from "./user_info.vue?vue&type=script&lang=js"
import style0 from "./user_info.vue?vue&type=style&index=0&id=c9faa016&prod&scoped=true&lang=css"
import style1 from "./user_info.vue?vue&type=style&index=1&id=c9faa016&prod&lang=css"
import style2 from "./user_info.vue?vue&type=style&index=2&id=c9faa016&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9faa016",
  null
  
)

export default component.exports